import axios from "axios";
import React, { useCallback, useMemo } from "react";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { Card, GridLegacy } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import Button from "../../../../components/CustomButtons/Button";
import { useFormContext, useWatch } from "react-hook-form";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { toast } from "react-toastify";
import MenuSyncSettings from "../MenuSyncSettings";

function Nuvopos() {
  const { menukaartVestigingId, vestigingId, reloadDataFromServer } = useFormContext();

  const nuvoposAccessTokenValue = useWatch({ name: "apiaccounts__nuvoposAccessToken" });
  const nuvoposEmailValue = useWatch({ name: "nuvoposEmail" });
  const nuvoposPasswordValue = useWatch({ name: "nuvoposPassword" });

  const showUsernamePassword = useMemo(() => !(nuvoposAccessTokenValue?.length > 0), [nuvoposAccessTokenValue]);

  const getAccessToken = useCallback(() => {
    let url = "/import/nuvopos/firsttimesetup?vid=" + vestigingId;
    url += "&token=true";
    url += "&email=" + nuvoposEmailValue;
    url += "&password=" + nuvoposPasswordValue;

    axios.get(url, { baseURL: "" }).then((response) => {
      if (response.data.success) {
        toast.success(response.data.message);
        reloadDataFromServer();
      } else {
        toast.error(response.data.message);
        reloadDataFromServer();
      }
    });
  }, [nuvoposEmailValue, nuvoposPasswordValue, vestigingId]);

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            {showUsernamePassword ? (
              <>
                <FormTextTC name={"nuvoposEmail"} tKey={"email"} />
                <FormTextTC name={"nuvoposPassword"} tKey={"Password"} textFieldType={"password"} />
                <GridLegacy item xs={12}>
                  <Button color={"primary"} onClick={getAccessToken} size={"sm"}>
                    <TranslationWrapper tKey={"Request accesstoken"} />
                  </Button>
                </GridLegacy>
              </>
            ) : null}
            <FormTextTC name={"apiaccounts__nuvoposAccessToken"} tKey={"AccessToken"} />
            <FormTextTC name={"apiaccounts__nuvoposBookingProviderId"} tKey={"Booking provider"} />
            <FormTextTC name={"apiaccounts__nuvoposPrintLocation"} tKey={"Print Locations"} />
            <FormTextTC name={"apiaccounts__nuvoposPaymentId"} tKey={"Payment id"} />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
            <MenuSyncSettings />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Nuvopos;
